import React from "react";

const ButtonOutlineWithIcon = ({ onClick, id, name, label, icon }) => {
  return (
    <button
      id={id}
      name={name}
      onClick={onClick}
      className=" font-lato px-5 py-[0.625rem] flex items-center gap-[1rem]
       text-center border-2 border-solid bg-white transition-all text-secondary-color active:bg-[#e6ebed] active:border-[#043b48] 
      ease-in-out duration-200 hover:bg-[#9bb1b6] border-secondary-color rounded-[0.675rem] p-[0.675rem]"
    >
      <img src={icon} alt="plus icon" className="w-[0.9rem] h-[0.9rem]" />
      {label}
    </button>
  );
};

export default ButtonOutlineWithIcon;
